import React, { useEffect } from "react";
import { Route, Routes } from "react-router-dom";

import Aos from "aos";
import "aos/dist/aos.css";

import Home from "./pages/Home.js";

function App() {
  useEffect(() => {
    Aos.init({
      duration: 3000,
      once: true,
      disable: window.innerWidth < 969 ? true : false,
    });
  }, []);

  return (
    <>
      <Routes>
        <Route path="*" element={<Home />} />
      </Routes>
    </>
  );
}

export default App;
